module.exports = __webpack_public_path__ + "img/hr-red-desert-bush-19.f26abe18.png";